import React, {useContext, useState} from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import {useAuth} from "../../../hooks/useAuth";
import {useNavigate} from "react-router-dom";
import * as Yup from "yup";
import ResetPassword from "../ResetPassword/ResetPassword";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import {ToasterContext} from "../../shared/Toaster/ToasterContext";
import {NotificationType} from "../../../constants/global";

import './forgotPassword.css';
import {routeConfigs} from "../../../navigation/routeConfig";
import {CircularProgress} from "@mui/material";

const ForgotPassword: React.FunctionComponent = () => {
  const {addToast} = useContext(ToasterContext);
  const [isConfirmed, setIsConfirmed] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [userName, setUserName] = useState<string>('');
  const auth: any = useAuth();
  const navigate  = useNavigate();

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required('Email is Required'),
  });

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(validationSchema)
  });

  const onSubmit = async (data: any) => {
    setLoading(true);
    setUserName(data.email);
    const result = await auth.forgotPassword( data.email );

    if (result.success) {
      setLoading(false);
      addToast({ type: NotificationType.Success, title: 'Code has been sent.'  });
      setIsConfirmed(true);
    } else {
      setLoading(false);
      setIsConfirmed(false);
      addToast({ type: NotificationType.Error,  title: result.message });
    }
  };

  return (
    <>
      <Typography component="h1" variant="h5">
        {isConfirmed ? 'Reset Password' : 'Forgot Password'}
      </Typography>
      {isConfirmed ? (
        <ResetPassword setIsConfirmed={setIsConfirmed} username={userName} />
      ) : (
        <Box component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{mt: 2}}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            autoComplete="email"
            helperText={errors.email?.message?.toString()}
            {...register('email')}
            error={!!errors.email}
            autoFocus
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{mt: 3, mb: 2}}
          >
            Send
            { loading && <CircularProgress sx={{ml: 1}} size={14} color='inherit' />}
          </Button>
          <Button
            type="submit"
            fullWidth
            variant="outlined"
            sx={{mt: 3, mb: 2}}
            onClick={() => navigate('/login')}
          >
            Back
          </Button>
          <Grid container>
            <Grid item>
              Don't have an account?
              <Link href={routeConfigs.signUp.path} sx={{ml: 1}} variant="body2">
                Sign Up
              </Link>
            </Grid>
          </Grid>
        </Box>
      )}
    </>
  )
}

export default ForgotPassword;